import { FeedbackParam } from '../types/backendService';

export const colorForFeedback = (feedback: FeedbackParam): string => {
  if (feedback.level === "INFO") {
    return "neutral70";
  } else if (feedback.feedbackCategory == "Positive") {
    return "primary70";
  } else {
    return "yellow70";
  }
};